import { z } from 'zod'

import { zSelect } from 'Lib/zod'

import { FORM_MESSAGES_MAP } from 'Constants/formMessages'

import { DeviceIdentifierTypeEnum } from './PublicRequestReturnLabel.types'

const deviceIdentifierSchema = z.object({
  identifierType: z.nativeEnum(DeviceIdentifierTypeEnum, {
    errorMap: () => ({ message: FORM_MESSAGES_MAP.REQUIRED }),
  }),
  value: z.string(),
})

const baseFormFields = {
  city: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
  companyName: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
  contactEmail: z.string().email(FORM_MESSAGES_MAP.EMAIL),
  contactName: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
  country: zSelect.refine(arg => !!arg?.value, FORM_MESSAGES_MAP.REQUIRED),
  senderName: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
  street: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
  zipcode: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
}

export const publicRequestReturnLabelFormSchema = z.object({
  ...baseFormFields,
  devices: z.array(deviceIdentifierSchema),
})

export const publicRequestReturnLabelHashFormSchema = z.object({
  ...baseFormFields,
  devices: z.any().optional(),
})
